<template>
	<div v-if="isDevelopmentEnvironment">
		<v-list-item>
			<v-list-item-avatar>
				<v-icon color="error" x-large>far fa-debug</v-icon>
			</v-list-item-avatar>

			<v-list-item-content>
				<v-list-item-title>
					<h3>{{ this.getBtnTitle }}</h3>
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
	</div>
</template>

<script>
export default {
	name: 'PuiDevelopmentEnvironment',
	data() {
		return {
			isDevelopmentEnvironment: false,
			urlIsDevelopment: '/puivariable/isDevelopmentEnvironment'
		};
	},
	computed: {
		getBtnTitle() {
			return this.$t('puimenu.titleDevEnv');
		}
	},
	created() {
		this.$puiRequests.getRequest(
			this.urlIsDevelopment,
			null,
			(response) => {
				this.isDevelopmentEnvironment = response.data;
				this.$store.commit('setDevelopmentEnvironment', response.data);
			},
			() => {}
		);
	}
};
</script>
